import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';

import {UserIdleService} from 'angular-user-idle';
import {routerTransition} from '@app/router.animations';
import {LoginService, ModuleService} from '@app/shared/services';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    TranslatePipe
  ],
  animations: [routerTransition()]
})
export class LoginComponent {
  public error_message = "";
  public user = "";
  public pass = "";

  constructor(
    private translate: TranslateService,
    public router: Router,
    public rest: LoginService,
    public modules: ModuleService,
    private userIdle: UserIdleService
  ) {
    this.translate.addLangs(['en', 'fr', 'ur', 'es', 'it', 'fa', 'de', 'zh-CHS']);
    this.translate.setDefaultLang('en');
    const browserLang = this.translate.getBrowserLang();
    if (browserLang != null) {
      this.translate.use(browserLang?.match(/en|fr|ur|es|it|fa|de|zh-CHS/) ? browserLang : 'en');
    }
  }

  getAccessTypes() {
    this.rest.getAccessTypes().subscribe((data: any) => {
      if (data['status'] == 'Success') {
        if (data['user_access_types']["status"] == 'Success') {
          localStorage.setItem('access_types', JSON.stringify(data['user_access_types']['data']));
        }
      }

    });
  }

  getInstitution() {
    this.rest.getInstitution().subscribe((data: any) => {
      if (data["status"] == 'Success') {
        localStorage.setItem('institution', JSON.stringify(data['data']));
        localStorage.setItem('logo_path', JSON.stringify(data['logo_path']));

      }
    });
  }

  onLoggedin() {
    if (this.user == "") {
      this.error_message = "<strong>Invalid </strong> User";
      setTimeout(() => {

        this.error_message = "";

      }, 4000);
    } else if (this.pass == "") {
      this.error_message = "<strong>Invalid </strong> Password";
      setTimeout(() => {

        this.error_message = "";

      }, 4000);
    } else {

      const login_data = {
        log_user: this.user,
        log_pass: this.pass
      };
      this.rest.checkCredentials(login_data).subscribe((result: any) => {
        window.scrollTo(0, 0)
        if (result["status"] == "Success") {
          localStorage.setItem('isLoggedin', 'true');
          const date = new Date();
          localStorage.setItem('activeTime', date.toString());
          localStorage.setItem('user', JSON.stringify(result["data"]));
          this.getAccessTypes();
          this.getInstitution();
          this.userIdle.startWatching();
          this.userIdle.onTimerStart().subscribe(count => console.log(count));
          this.userIdle.ping$.subscribe(() => {
            const date = new Date();
            localStorage.setItem('activeTime', date.toString());
          });
          this.userIdle.onTimeout().subscribe(() => {

            localStorage.removeItem('isLoggedin');
            localStorage.removeItem('activeTime');
            localStorage.removeItem('user');
            localStorage.removeItem('modules');
            localStorage.removeItem('sub_modules');
            localStorage.removeItem('access_types');
            localStorage.removeItem('user_rights');
            localStorage.removeItem('institution');
            localStorage.removeItem('logo_path');
            this.router.navigate(['login']).then();
          });

          const path: string = result["data"]["redirect_page"].toString();
          this.loadModules(path);

        } else {
          this.error_message = result["message"];
          setTimeout(() => {

            this.error_message = "";

          }, 4000);
        }
      });
    }

  }

  public loadModules(path: string) {
    const userCredentials = JSON.parse(localStorage.getItem('user') ?? "{}");
    const sentData = {
      user_group: userCredentials.user_login
    };
    this.modules.getModules(sentData).subscribe((result: any) => {
      window.scrollTo(0, 0)
      if (result["status"] == "Success") {
        localStorage.setItem('modules', JSON.stringify(result["data"]));
        this.router.navigate([path]).then();
      }
    });
  }
}
